/**
 * Project Name : cop-web-portal
 * File Name : index.js
 * Description : vue-toast 추가
 * Author : dhoop.lee
 * Date : 2023.7.13
 */
import VueToast from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import CommonToast from "./CommonToast.vue";

export default {
  install(Vue, options) {
    Vue.use(VueToast);
    /**
    * param msg
    * return toast popup
    * exception
    * description 성공 toast popup
    * since 2023-07-13
    */
    const openSuccessToast = (msg) => Vue.$toast.success(msg, {
      position: 'bottom-left',
      toastClassName: 'toast_bg_success',
    });
    /**
     * param msg
     * return toast popup
     * exception
     * description Info toast popup
     * since 2023-07-13
     */
    const openInfoToast = (msg) => Vue.$toast.info(msg, {
      position: 'bottom-left',
      toastClassName: 'toast_bg_info',
    });
    /**
     * param msg
     * return toast popup
     * exception
     * description Error toast popup
     * since 2023-07-13
     */
    const openErrorToast = (msg) => Vue.$toast.error(msg, {
      position: 'bottom-left',
      toastClassName: 'toast_bg_warning',
    });
    /**
     * param msg
     * return toast popup
     * exception
     * description Warning toast popup
     * since 2023-07-13
     */
    const openWarningToast = (msg) => Vue.$toast.warning(msg, {
      position: 'bottom-left',
      toastClassName: 'toast_bg_error',
    });
    /**
     * param msg, click function
     * return toast popup
     * exception
     * description 버튼이 있는 공통 Toast Popup
     * since 2023-07-13
     */
    const openCommonToast = (msg,fnc) => Vue.$toast({
      component: CommonToast,
      props: {
        msg,
      },
      listeners: {
        fnc,
      },
      icon: false,
      position: 'top-right',
    });
    Vue.prototype.openSuccessToast = openSuccessToast;
    Vue.prototype.openInfoToast = openInfoToast;
    Vue.prototype.openErrorToast = openErrorToast;
    Vue.prototype.openWarningToast = openWarningToast;
    Vue.prototype.openCommonToast = openCommonToast;
  },
};



// WEBPACK FOOTER //
// ./src/toast/index.js